import React from "react";
import "./Location.css";
import Toronto from "../../../images/populerCities/Toronto.jpg";
import Paris from "../../../images/populerCities/Paris.jpg";
import NewYork from "../../../images/populerCities/New-York.jpg";
import TelAviv from "../../../images/populerCities/Tel-Aviv.jpg";
import London from "../../../images/populerCities/London.jpg";
import Dubai from "../../../images/populerCities/Dubai.jpg";
import Seychelles from "../../../images/populerCities/Seychelles.jpeg";
import headerBg from "../../../images/header-bg.png";
import LocationItems from "./LocationItems";
import { Fade } from "react-reveal";

const Location = () => {
  const data = [
    {
      img: Paris,
      place: "Paris",
    },
    {
      img: NewYork,
      place: "New York",
    },
    {
      img: TelAviv,
      place: "Tel Aviv",
    },
    {
      img: London,
      place: "London",
    },
    {
      img: Dubai,
      place: "Dubai",
    },
    {
      img: Toronto,
      place: "Toronto",
    },
    {
      img: Seychelles,
      place: "Seychelles",
    },
    {
      img: "https://www.weshare.buzz/images/popularLocation/small_640cfab675d449a1187ffe26c17f3161.jpeg",
      place: "Greater London",
    },
    {
      img: "https://www.weshare.buzz/images/popularLocation/small_9b1373af96b5dff40edd6bd9e7735cdb.jpeg",
      place: "Oristano",
    },
  ];
  return (
    <div className="">
      <div className="container pt-3">
        {/* <h1 className="sectionHeader2">
          <span className="text-yellow2">Popular </span>
          <span className="text-blue2" style={{ position: "relative" }}>
            Cities
            <span className="headerPsudo2">
              <img src={headerBg} alt="" />
            </span>
            <span className="headerPsudoText2">
              <span className="p">a sustainable lifestyle</span>
            </span>
          </span>
        </h1> */}
        <div className="main_title">
          <Fade left>
            <h1 className="sectionHeader111 py-5">
              <span className="text-yellow">Popular </span>
              <span className="text-blue">
                Cities{" "}
                <span className="headerPsudo222">
                  <img src={headerBg} alt="" />
                </span>
              </span>
            </h1>
          </Fade>
        </div>
        <div className="galleryBody pt-3">
          {data.slice(0, 5).map((item, index) => (
            <LocationItems
              idx={index}
              img={item.img}
              place={item.place}
              key={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Location;
